import iconMap from "../../assets/icons/icon-map";

const Icon = ({ name, size = 23, color, className, style, onClick, ...rest }) => {
  const EmptyIcon = () => <div />;
  const SvgIcon = iconMap[name] || EmptyIcon;

  return (
    <SvgIcon
      style={{
        width: size,
        height: size,
        fill: color,
        ...rest,
        ...(style && { ...style }),
      }}
      className={className}
      onClick={typeof onClick === "function" ? onClick : ()=>{} }
    />
  );
};

export default Icon;
